import { createAsyncThunk } from "@reduxjs/toolkit";
import { REPORT } from "../../utils/constants/APIURL.constants";
import AppService from "../../services/AppService";
import { getQueryUrl } from "../../helpers/authhelper";

export const getAllIssues = createAsyncThunk(
  "admin/issuesList",
  async (params, { rejectWithValue }) => {
    const url = REPORT.REPORTS + "?" + getQueryUrl(params);
    try {
      const data = await AppService.getCall(url);
      return { data: data.result, totalRowCount: data.count };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const getIssuesById = createAsyncThunk(
  "admin/getIssuesById",
  async (id, { rejectWithValue }) => {
    const url = REPORT.REPORTS + id + "/";
    try {
      const data = await AppService.getCall(url);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const UpdateIssuesById = createAsyncThunk(
  "admin/updateIssuesById",
  async (obj, { rejectWithValue }) => {
    const url = REPORT.REPORTS + obj.ticket_id + "/";
    try {
      const data = await AppService.putCall(obj.reqBody, url);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const deleteIssueImage = createAsyncThunk(
  "admin/deleteIssueImage",
  async (obj, { rejectWithValue }) => {
    const url = `${REPORT.REPORTS}?report_issue_image=${obj.id}`;
    try {
      const data = await AppService.deleteCall(url);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
